import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function RecanalizadorDeCarga() {
  return (
    <ClipperPlaceholder title="Recanalizador de Carga" category="Operativas" />
  );
}
